import { TabsItemProps } from "./types"

export const TabsItem = (_props: TabsItemProps) => {
  // The TabsInner component controls the render of the TabsItems
  return null
}

TabsItem.displayName = "Tabs.Item"
